
import Request from './request';

export default class Issue extends Request {

    query( num ) {
        return `query {
            repository(owner: "${ this.user }", name: "${ this.repo }") {
                issue(number: ${ num }) {
                    title
                    number
                    createdAt
                    author {
                        login
                    }
                    body
                    bodyHTML
                    bodyText
                    labels(first: 10) {
                        edges {
                            node {
                                name
                            }
                        }
                    }
                    comments(first: 10) {
                        edges {
                            node {
                                author {
                                    login
                                    avatarUrl
                                    url
                                }
                                body
                                bodyHTML
                                bodyText
                                createdAt
                            }
                        }
                    }
                }
            }
        }`;
    }

    getId( num ) {
        return `query {
            repository(owner: "${ this.user }", name: "${ this.repo }") {
                issue(number: ${ num }) {
                    id
                }
            }
        }`;
    }

    queryComments( num, after ) {
        return `query {
            repository(owner: "${ this.user }", name: "${ this.repo }") {
                issue(number: ${ num }) {
                    title
                    number
                    createdAt
                    author {
                        login
                    }
                    body
                    bodyHTML
                    bodyText
                    labels(first: 10) {
                        edges {
                            node {
                                name
                            }
                        }
                    }
                    comments(first: 40, ${ after ? `after: "${ after }",` : '' } orderBy: { field: UPDATED_AT, direction: DESC }) {
                        totalCount
                        pageInfo {
                            hasPreviousPage
                            startCursor
                            hasNextPage
                            endCursor
                        }
                        edges {
                            node {
                                author {
                                    login
                                    avatarUrl
                                    url
                                }
                                body
                                bodyHTML
                                bodyText
                                createdAt
                            }
                        }
                    }
                }
            }
        }`;
    }

}